import React, { useCallback, useEffect, useState } from "react";
import { adminApi } from "../services/adminApi";
import usePolling from "../hooks/usePolling";
import Pagination from "../components/Pagination";

export default function LicenseManagement() {
  const [status, setStatus] = useState("");
  const [data, setData] = useState({
    items: [],
    summary: {},
    total: 0,
    page: 1,
    pageSize: 10,
  });
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    try {
      const next = await adminApi.getLicenses({
        page: data.page,
        pageSize: data.pageSize,
        status: status || undefined,
      });
      setData(next);
      setError("");
    } catch (err) {
      setError(err?.response?.data?.error || "Failed to load license data");
    }
  }, [status, data.page, data.pageSize]);

  usePolling(load, 30000, [status, data.page, data.pageSize]);

  useEffect(() => {
    setData((prev) => (prev.page === 1 ? prev : { ...prev, page: 1 }));
  }, [status]);

  const assign = async (userId) => {
    try {
      await adminApi.assignLicense(userId);
      await load();
    } catch (err) {
      setError(err?.response?.data?.error || "Failed to assign license");
    }
  };

  const revoke = async (userId) => {
    try {
      await adminApi.revokeLicense(userId);
      await load();
    } catch (err) {
      setError(err?.response?.data?.error || "Failed to revoke license");
    }
  };

  return (
    <div>
      <h2>License / Plan Management</h2>
      <div className="row" style={{ marginBottom: 12 }}>
        <select value={status} onChange={(e) => setStatus(e.target.value)}>
          <option value="">All</option>
          <option value="active">Active</option>
          <option value="none">No License</option>
        </select>
        <button className="btn-primary" onClick={load}>Refresh</button>
      </div>
      {error ? <div className="error">{error}</div> : null}

      <div className="row" style={{ marginBottom: 12 }}>
        <div className="card">Active Plans: {data.summary?.activePlans || 0}</div>
        <div className="card">Expired Plans: {data.summary?.expiredPlans || 0}</div>
        <div className="card">Users Without License: {data.summary?.usersWithoutLicense || 0}</div>
      </div>

      <div className="card">
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>User</th>
                <th>Email</th>
                <th>Status</th>
                <th>Purchased At</th>
                <th>License Tx</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {(data.items || []).map((item) => (
                <tr key={item.user.id}>
                  <td>{item.user.name}</td>
                  <td>{item.user.email}</td>
                  <td>{item.status}</td>
                  <td>{item.purchasedAt ? new Date(item.purchasedAt).toLocaleString() : "-"}</td>
                  <td>{item.transactionId || "-"}</td>
                  <td>
                    {item.hasLicense ? (
                      <button className="btn-danger" onClick={() => revoke(item.user.id)}>
                        Revoke
                      </button>
                    ) : (
                      <button className="btn-primary" onClick={() => assign(item.user.id)}>
                        Assign
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <Pagination
          page={data.page}
          pageSize={data.pageSize}
          total={data.total}
          onPageChange={(nextPage) =>
            setData((prev) => ({
              ...prev,
              page: nextPage,
            }))
          }
        />
      </div>
    </div>
  );
}
